import React, { memo } from "react";
import Breadcrumbs from "../../../components/Breadcrumbs";
import "./index.css";
import { useFreire } from "../../../utils/freireContext";
import * as texts from "../locales";

const SystemAvailability = memo(() => {
  const { freire } = useFreire();

  return (
    <div className="container">
      <Breadcrumbs
        breadcrumbs={[
          freire(texts.ADMIN),
          freire(texts.AVAILABILITY),
          freire(texts.SYSTEM),
        ]}
      />
      <div className="dashboard-wrapper">
        <iframe
          title="Status Page"
          src="https://tupimob.statuspage.io"
          frameBorder={0}
          width="100%"
          style={{ height: "calc(100vh - 180px)" }}
        />
      </div>
    </div>
  );
});

export default SystemAvailability;
